export default __webpack_public_path__ + "static/media/navBarLine.cf189cca.svg";